import colors from '@theme/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  align-items: center;
  padding-top: 40px;
  background-color: ${colors['$color-background-primary']};
`
